import React, { useEffect, useState } from "react";
import Header from "../components/ui/header/Header";

export default function SecondaryLayout({ children, isOpen, setOpen, id }) {
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setIsHeaderFixed(
        currentScrollPos < prevScrollPos && currentScrollPos > 0
      );
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);
  return (
    <div className=" relative overflow-x-hidden">
      <div
        className={`${
          isHeaderFixed ? "fixed fadeInDown" : "absolute "
        }  z-999 top-0 w-full bg-white`}
      >
        <Header
          isOpen={isOpen}
          setOpen={setOpen}
          type="secondary"
          isHeaderFixed={isHeaderFixed}
          id={id}
        />
      </div>
      <div>{children}</div>
    </div>
  );
}
